export type ModalFieldErrors = Record<string, string>;

export function modalValidationSummary(errors: ModalFieldErrors): string | null {
  const messages = Object.values(errors).filter(Boolean);
  if (messages.length === 0) return null;
  if (messages.length === 1) return messages[0];
  return `Fix ${messages.length} fields below.`;
}

export function firstModalValidationFieldId(errors: ModalFieldErrors): string | null {
  const id = Object.keys(errors)[0];
  return id ?? null;
}

export function scrollModalBodyToTarget(
  container: HTMLElement | null,
  target?: { elementId?: string; scrollTop?: boolean }
): void {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      if (target?.elementId) {
        const el = document.getElementById(target.elementId);
        if (!el) return;
        if (container) {
          const containerRect = container.getBoundingClientRect();
          const elementRect = el.getBoundingClientRect();
          const relativeTop = elementRect.top - containerRect.top + container.scrollTop;
          container.scrollTo({ top: Math.max(0, relativeTop - 20), behavior: 'smooth' });
        } else {
          el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
        if (
          el instanceof HTMLInputElement ||
          el instanceof HTMLTextAreaElement ||
          el instanceof HTMLSelectElement
        ) {
          el.focus({ preventScroll: true });
          return;
        }
        const focusable = el.querySelector<HTMLElement>(
          'input, textarea, select, button, [tabindex]:not([tabindex="-1"])'
        );
        focusable?.focus({ preventScroll: true });
        return;
      }
      if (target?.scrollTop) {
        container?.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  });
}

export function stripFieldIdPrefix(
  errors: ModalFieldErrors,
  prefix: string
): Record<string, string> {
  const result: Record<string, string> = {};
  const needle = `${prefix}-`;
  for (const [key, message] of Object.entries(errors)) {
    if (key.startsWith(needle)) {
      result[key.slice(needle.length)] = message;
    }
  }
  return result;
}

export function prefixFieldErrors(prefix: string, errors: Record<string, string>): ModalFieldErrors {
  const result: ModalFieldErrors = {};
  for (const [key, message] of Object.entries(errors)) {
    result[`${prefix}-${key}`] = message;
  }
  return result;
}
